import React, { useMemo } from 'react';
import { Center, Flex, Text } from '@chakra-ui/react';
import { ColumnDef } from '@tanstack/react-table';

import { CategoryQuantity, RelevoInventoryResponse, RelevosProductCategoryWithImage } from '../../../../../api/types';
import { TableType } from '../../../../../common/components/Table/model/enums/table-type.enum';
import { Table } from '../../../../../common/components/Table/Table';
import { useTranslations } from '../../../../../contexts/LocalizationContext';
import { useLocalizationContext } from '../../../../../contexts/LocalizationContext/useLocalizationContext.hook';
import { useScannedRelevosContext } from '../../../../../contexts/ScannedRelevosContext';

type UnknownItemsConfirmBodyProps = {
  categoriesToCreate: CategoryQuantity;
  inventory?: RelevoInventoryResponse;
};

export const UnknownItemsConfirmBody = ({ categoriesToCreate, inventory }: UnknownItemsConfirmBodyProps) => {
  const translations = useTranslations();
  const { applicationUser, quickContact } = useScannedRelevosContext();
  const { language } = useLocalizationContext();

  const columns = useMemo<ColumnDef<RelevosProductCategoryWithImage | undefined>[]>(
    () => [
      {
        id: 'category',
        header: translations('category_list_category'),
        cell: ({ row }) => <>{row.original?.translations[language]}</>,
      },
      {
        id: 'quantity',
        header: translations('category_list_quantity'),
        cell: ({ row }) => <>{row.original ? categoriesToCreate[row.original.id] : undefined}</>,
      },
    ],
    [categoriesToCreate, language, translations],
  );

  return (
    <Center py={4}>
      <Flex direction={'column'}>
        <Text pb={4} fontSize={20}>
          {translations('assign_items_confirm', {
            '{{user-id}}': applicationUser?.userId || quickContact?.quickContactName || '',
          })}
        </Text>
        <Table
          variant={'relevoSummary'}
          type={TableType.SIMPLE}
          data={Object.keys(categoriesToCreate)
            .map((categoryId) => inventory?.categoriesSummary?.find((category) => categoryId === category.id))
            .filter((category) => !!category)}
          columns={columns}
        />
      </Flex>
    </Center>
  );
};
